export default "__VITE_ASSET__d7e52414__"